import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import Item1 from 'assets/image/retail-landing-page/stuff/lunchbox-1.png'
import Item2 from 'assets/image/retail-landing-page/stuff/lunchbox-2.png'
import Item3 from 'assets/image/retail-landing-page/stuff/lunchbox-3.png'
import Item4 from 'assets/image/retail-landing-page/stuff/lunchbox-4.png'
import Item5 from 'assets/image/retail-landing-page/stuff/lunchbox-5.png'
import Item6 from 'assets/image/retail-landing-page/stuff/paperbowl-1.png'
import Item7 from 'assets/image/retail-landing-page/stuff/paperbowl-2.png'
import Item8 from 'assets/image/retail-landing-page/stuff/paperbowl-3.png'
import Item9 from 'assets/image/retail-landing-page/stuff/papercup-1.png'
import Item10 from 'assets/image/retail-landing-page/stuff/papercup-2.png'
import Item11 from 'assets/image/retail-landing-page/stuff/papercup-3.png'
import Item12 from 'assets/image/retail-landing-page/stuff/papercup-4.png'
import Item13 from 'assets/image/retail-landing-page/stuff/papertray-1.png'
import Item14 from 'assets/image/retail-landing-page/stuff/papertray-2.png'
import Item15 from 'assets/image/retail-landing-page/stuff/plasticlid-1.png'
import Item16 from 'assets/image/retail-landing-page/stuff/plasticlid-2.png'
import Item17 from 'assets/image/retail-landing-page/stuff/uncategorized-1.png'
import Item18 from 'assets/image/retail-landing-page/stuff/uncategorized-2.png'

const filters = [
  { id: 1, name: 'Semua Produk' },
  { id: 2, name: 'Paper Bowl' },
  { id: 3, name: 'Plastic Lid' },
  { id: 4, name: 'Paper Cup' },
  { id: 5, name: 'Lunch Box' },
  { id: 6, name: 'Paper Tray' }
]

const items = [
  { name: 'Lunch Box', img: Item1, categories: [1, 5] },
  { name: 'Lunch Box', img: Item2, categories: [1, 5] },
  { name: 'Lunch Box', img: Item3, categories: [1, 5] },
  { name: 'Lunch Box', img: Item4, categories: [1, 5] },
  { name: 'Lunch Box', img: Item5, categories: [1, 5, 6] },
  { name: 'Paper Bowl', img: Item6, categories: [1, 2] },
  { name: 'Paper Bowl', img: Item7, categories: [1, 2, 6] },
  { name: 'Paper Bowl', img: Item8, categories: [1, 2] },
  { name: 'Paper Cup', img: Item9, categories: [1, 4] },
  { name: 'Paper Cup', img: Item10, categories: [1, 4] },
  { name: 'Paper Cup', img: Item11, categories: [1, 4] },
  { name: 'Paper Cup', img: Item12, categories: [1, 4] },
  { name: 'Paper Tray', img: Item13, categories: [1, 6] },
  { name: 'Paper Tray', img: Item14, categories: [1, 6] },
  { name: 'Plastic Lid', img: Item15, categories: [1, 3] },
  { name: 'Plastic Lid', img: Item16, categories: [1, 3] },
  { name: 'filler', img: Item17, categories: [1] },
  { name: 'Uncategorized', img: Item17, categories: [1] },
  { name: 'Uncategorized', img: Item18, categories: [1] }
]

const Stuff = () => {
  const [selectedType, setSelectedType] = useState(1)
  return (
    <div className="bg-[#F4633A]">
      <section className="px-6 lg:px-14 xl:px-[120px] m-auto left-0 right-0 pt-10 pb-10 md:py-[96px] max-w-[1440px] lg:py-20 xl:py-[88px]">
        <h1 className="h4-bold xl:h3-bold text-center max-w-[773px] sm:w-full m-auto left-0 right-0 relative text-white">
          <Pattern />
          Pilihan barang lengkap di Manuva Retail
        </h1>
        <div className="hidden xl:flex items-center justify-between mt-[40px] mb-[60px]">
          <div className="flex items-center rounded-[40px]">
            {filters.map(({ id, name }) => (
              <div
                key={id}
                onClick={() => setSelectedType(id)}
                className={clsx(
                  'cursor-pointer w-[100px] lg:w-fit rounded-[40px] px-[16px] py-3.5 lg:px-7 text-base lg:text-lg font-normal leading-[150%]',
                  selectedType === id
                    ? 'text-white bg-white text-[#F4633A] font-medium'
                    : 'text-white hover:bg-[#fff]/[0.5] hover:text-white'
                )}
              >
                <div className="flex items-center gap-x-[10px]">{name}</div>
              </div>
            ))}
          </div>
          <div className="flex items-center">
            <Search className="mr-4" />
            <Filter />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-[24px] md:gap-[32px] w-full mt-[32px] md:mt-[72px] xl:mt-0">
          {items
            .filter((el) => el.categories.includes(selectedType))
            .map(({ name, img }, idx) => (
              <div className={name === 'filler' ? 'lg:hidden md:block hidden opacity-0' : ''} key={idx}>
                <div className="w-full aspect-square bg-[#fff]/[.2] cursor-pointer transition duration-200 border-2 border-transparent hover:border-white grid place-content-center">
                  <img src={img} className="w-full h-full object-contain" />
                </div>
                <p className="text-neutral-20 text-center mt-[12px]">{name}</p>
              </div>
            ))}
        </div>
        <p className="xl:hidden mt-[40px] md:mt-[64px] text-center text-base md:text-lg leading-[160%] md:leading-[150%] text-white">
          Cup Bowl Polos • Cup Bowl 3 Ayam • Paper Cup Hot • Paper Cup Motif Mix
          • Sendok dan Garpu • Lunch Box Sekat • Lunch Box • Thinwall DM - Bulat
          • Thinwall DM - Square • Thinwall DM - Persegi Panjang • Thinwall DM
          Cup • Thinwall DM - Rounded • Thinwall DM Sauce P.1 • Thinwall DM
          Sauce P.1.5 Paper Tray • Plastic Cup • Lid Hot Cup Natural • Lid Hot
          Cup Black • Lid Ice Cream • Lid Bowl • dan masih banyak lagi!
        </p>
      </section>
    </div>
  )
}

const Pattern = () => (
  <svg
    className="absolute top-[50%] translate-y-[-50%] left-[-20px]"
    width="135"
    height="89"
    viewBox="0 0 135 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.716 88.9342C23.9379 83.8298 36.8047 30.4982 78.756 21.387V0.438477C60.5389 3.14622 36.675 14.1236 23.586 33.4621L22.6049 34.9257L22.716 13.7211H0V88.8611L22.716 88.9342Z"
      fill="white"
      fillOpacity="0.12"
    />
    <path
      d="M135 0.438477V21.387C93.0486 30.5347 80.1633 83.8298 78.9599 88.9342H56.1514V40.4876C65.7783 31.1385 75.4423 28.2112 78.8488 28.138V34.9074L79.83 33.4621C92.9004 14.1236 116.857 3.14622 135 0.438477"
      fill="white"
      fillOpacity="0.12"
    />
    <path
      d="M134.999 28.1375V88.9337H112.302V40.487C121.91 31.1379 131.593 28.2106 134.999 28.1375Z"
      fill="white"
      fillOpacity="0.12"
    />
  </svg>
)

const Search = ({ className, ...props }) => (
  <svg
    width="44"
    height="45"
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`cursor-pointer ${className}`}
    {...props}
  >
    <rect y="0.5" width="44" height="44" rx="22" fill="white" />
    <path
      d="M21 30.5C25.9706 30.5 30 26.4706 30 21.5C30 16.5294 25.9706 12.5 21 12.5C16.0294 12.5 12 16.5294 12 21.5C12 26.4706 16.0294 30.5 21 30.5Z"
      stroke="#F4633A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 32.5L28 28.5"
      stroke="#F4633A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

Search.propTypes = {
  className: PropTypes.string
}

const Filter = ({ className, ...props }) => (
  <svg
    width="44"
    height="45"
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`cursor-pointer ${className}`}
    {...props}
  >
    <rect y="0.5" width="44" height="44" rx="22" fill="white" />
    <path
      d="M15.4004 12.6001H28.6004C29.7004 12.6001 30.6004 13.5001 30.6004 14.6001V16.8001C30.6004 17.6001 30.1004 18.6001 29.6004 19.1001L25.3004 22.9001C24.7004 23.4001 24.3004 24.4001 24.3004 25.2001V29.5001C24.3004 30.1001 23.9004 30.9001 23.4004 31.2001L22.0004 32.1001C20.7004 32.9001 18.9004 32.0001 18.9004 30.4001V25.1001C18.9004 24.4001 18.5004 23.5001 18.1004 23.0001L14.3004 19.0001C13.8004 18.5001 13.4004 17.6001 13.4004 17.0001V14.7001C13.4004 13.5001 14.3004 12.6001 15.4004 12.6001Z"
      stroke="#F4633A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.93 12.6001L16 20.5001"
      stroke="#F4633A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

Filter.propTypes = {
  className: PropTypes.string
}

export default Stuff
